import App from 'app/App';
import React from 'react';
import ReactDOM from 'react-dom/client';

const rootDOM = document.getElementById('root');
if (rootDOM) {
  const root = ReactDOM.createRoot(rootDOM);
  root.render(<App />);
}
